import Vue from "vue";
import axios from "axios";
import Auth from "./aws-amplify";

const s3_Public = axios.create({
  baseURL: process.env.VUE_APP_AWS_S3_PUBLIC_API_BASE_URL,
  timeout: 10000
  // headers: { 'X-CUSTOM-HEADER': 'foobar' }
});

const s3_Private = axios.create({
  baseURL: process.env.VUE_APP_AWS_S3_PRIVATE_API_BASE_URL,
  timeout: 10000
  // headers: { 'X-CUSTOM-HEADER': 'foobar' }
});

const authNoToken = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 10000
  // headers: { 'X-CUSTOM-HEADER': 'foobar' }
});

const auth = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 1200000
  // headers: { 'X-CUSTOM-HEADER': 'foobar' }
});

auth.interceptors.request.use(
  async config => {
    const currentSession = await Auth.currentSession();
    const accessToken = currentSession.getAccessToken().getJwtToken();
    config.headers = {
      Authorization: `Bearer ${accessToken}`,
      Accept: "application/json",
      "Content-Type": "application/x-www-form-urlencoded"
    };
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

Vue.prototype.$axiosS3Public = s3_Public;
Vue.prototype.$axiosS3Private = s3_Private;
Vue.prototype.$axiosAuth = auth;
Vue.prototype.$axiosAuthNoToken = authNoToken;
Vue.prototype.$axios = axios;
